export const ITEM_CUSTOMIZATION_ID = "icid";
export const COMBO_CUSTOMIZATION_ID = "ccid";
export const GIFT_CARD_ID = "gcid;";
export const REQUESTING_CC_PAYMENT = "requestingCCPayment";
export const IS_EZ_CATER_PICKUP = "isEzCaterPickup";
export const TENDER_NAME = "tenderName";
